import {
  FETCH_LIST,
  LIST_FETCHED,
  SHOW_INFO_DIALOG,
  HIDE_INFO_DIALOG,
  UPDATED,
  CREATED,
  TOGGLE_LOADING,
  SET_ACTIVE_STATE,
  SET_DEFAULT,
  DEL_DEFAULT
} from './actionTypes'

export const fetchList = (tenantId, params) => ({
  type: FETCH_LIST,
  payload: {
    tenantId,
    params
  }
})

export const listFetched = result => ({
  type: LIST_FETCHED,
  payload: result
})

export const showInfoDialog = params => ({
  type: SHOW_INFO_DIALOG,
  payload: { params }
})

export const hideInfoDialog = () => ({
  type: HIDE_INFO_DIALOG
})

export const toggleLoading = () => ({
  type: TOGGLE_LOADING
})

export const updated = (type, valuesType, data, originalValue, values) => ({
  type: UPDATED,
  payload: { type, valuesType, data , originalValue, values }
})

export const setdefault = (valuesType, row) => ({
  type: SET_DEFAULT,
  payload: { valuesType, row }
})

export const deldefault = (valuesType, row) => ({
  type: DEL_DEFAULT,
  payload: { valuesType, row }
})

export const created = (type, valuesType, data, values) => ({
  type: CREATED,
  payload: { type, valuesType, data, values}
})

export const setActiveState = (id, isActive) => ({
  type: SET_ACTIVE_STATE,
  payload: { id, isActive }
})
